<template>
  <aside>
    <div class="fixed">
      <div class="container">
        <div class="header">
          <h1 class="bi" @click="goHome('/')">
            보이스캐디
          </h1>
          <div class="close" @click="menuToggle">
            닫기
          </div>
        </div>
        <div class="body">
          <ul class="navigation">
            <!-- 아코디언(Class) : accordion / 활성(Class) : active -->

            <li el-data="/HO201">
              <div class="item" @click="moveMenu('/HO201')">
                APL 전국 현황
              </div>
            </li>
            <li el-data="/HO101">
              <div class="item" @click="goHome('/')">
                홈
              </div>
            </li>
            <li el-data="/AccountClubs">
              <div class="item" @click="moveMenu('/account-clubs')">
                코스 선택
              </div>
            </li>
            <li el-data="/RD00">
              <div class="item" @click="moveMenu('/RD001')">
                비 정상 현황
              </div>
            </li>
            <li el-data="/CD00">
              <div class="item" @click="moveMenu(userInfo.userRole !== 'ClubManager' ? '/CD001' : `/CD002`)">
                {{ userInfo.userRole === 'ClubManager' ? '기기상태' : '골프장별 현황' }}
              </div>
            </li>
            <li class="accordion" el-data="/ST00" @click="accordionToggle($event)">
              <div class="item">
                통계
              </div>
              <ul>
                <li el-data="/ST001">
                  <div class="item"  @click="moveMenu('/ST001')">
                    비정상 원인
                  </div>
                </li>
                <li el-data="/ST002">
                  <div class="item"  @click="moveMenu('/ST002')">
                    기간별 가동률
                  </div>
                </li>
              </ul>
            </li>
            <!-- 아코디언(Class) : accordion / 활성(Class) : active -->
<!--            <li :class="currentPath.indexOf('/MR') > -1 ? 'active' : ''" el-data="/MR">-->
<!--              <div class="item" @click="moveMenu('/MR001')">-->
<!--                APL 운영 모니터링-->
<!--              </div>-->
<!--            </li>-->
            <!-- 아코디언(Class) : accordion / 활성(Class) : active -->
            <li class="accordion" :class="(currentPath.indexOf('/GR') > -1 || currentPath.indexOf('/CR') > -1 ) ? 'active' : ''" el-data="/GR" @click="accordionToggle($event)">
              <div class="item">
                {{ userInfo.userRole === 'ClubManager' ? '그린관제시스템' : '부가정보' }}
              </div>
              <ul>
                <!-- 활성(Class) : active -->
<!--                <li el-data="/GR001">-->
<!--                  <div class="item" @click="moveMenu('/GR001' + getCurrentCcodeParam())">-->
<!--                    요약-->
<!--                  </div>-->
<!--                </li>-->
                <!-- 활성(Class) : active -->
                <li el-data="/GR10">
                  <div class="item" @click="moveMenu('/GR101' + getCurrentCcodeParam())">
                    그린 온도
                  </div>
                </li>
                <!-- 활성(Class) : active -->
<!--                <li el-data="/GR201">-->
<!--                  <div class="item" @click="moveMenu('/GR201' + getCurrentCcodeParam())">-->
<!--                    APL 통신 &amp; 배터리-->
<!--                  </div>-->
<!--                </li>-->
                <!-- 활성(Class) : active -->
                <li el-data="/GR30">
                  <div class="item" @click="moveMenu('/GR301' + getCurrentCcodeParam())">
                    핀
                  </div>
                </li>
<!--              </ul>-->
<!--            </li>-->
<!--             아코디언(Class) : accordion / 활성(Class) : active -->
<!--            <li class="accordion" el-data="/CR" @click="accordionToggle($event)">-->
<!--              <div class="item">-->
<!--                코스분석-->
<!--              </div>-->
<!--              <ul>-->
                <!-- 활성(Class) : active -->
                <li el-data="/CR001">
                  <div class="item" @click="moveMenu('/CR001' + getCurrentCcodeParam())">
                    낙구지점 통계
                  </div>
                </li>
                <!-- 활성(Class) : active -->
                <li el-data="/CR101">
                  <div class="item" @click="moveMenu('/CR101' + getCurrentCcodeParam())">
                    핀 위치 통계
                  </div>
                </li>
              </ul>
            </li>
            <!-- 아코디언(Class) : accordion / 활성(Class) : active -->
            <li class="accordion" el-data="/SE" @click="accordionToggle($event)">
              <div class="item">
                설정
              </div>
              <ul>
                <!-- 활성(Class) : active -->
                <li el-data="/SE00">
                  <div class="item" @click="moveMenu(userInfo.userRole !== 'ClubManager' ? '/SE001' : `/SE002?ccode=${userInfo.ccode}`)">
                    골프클럽 관리
                  </div>
                </li>
                <!-- 활성(Class) : active -->
                <li el-data="/SE20">
                  <div class="item" @click="moveMenu('/SE201')">
                    알림 발송
                  </div>
                </li>
                <!-- 활성(Class) : active -->
                <li el-data="/SE21">
                  <div class="item" @click="moveMenu('/SE211')">
                    알림 수신 설정
                  </div>
                </li>
              </ul>
            </li>
            <li class="accordion" el-data="/CS" @click="accordionToggle($event)">
              <div class="item">
                고객센터
              </div>
              <ul>
                <!-- 활성(Class) : active -->
                <li el-data="/CS00">
                  <div class="item" @click="moveMenu('/CS001')">
                    공지사항
                  </div>
                </li>
                <!-- 활성(Class) : active -->
                <li el-data="/CS10">
                  <div class="item" @click="moveMenu('/CS101')">
                    1:1문의
                  </div>
                </li>
              </ul>
            </li>
            <li class="accordion" el-data="/MA" @click="accordionToggle($event)">
              <div class="item">
                관리
              </div>
              <ul>
                <!-- 활성(Class) : active -->
                <li el-data="/MA0">
                  <div class="item" @click="moveMenu('/MA001')">
                    사용자 관리
                  </div>
                </li>
<!--                <li el-data="/MA1">-->
<!--                  <div class="item" @click="moveMenu('/MA101')">-->
<!--                    비정상 홀 리스트-->
<!--                  </div>-->
<!--                </li>-->
              </ul>
            </li>
          </ul>

          <div class="version">
            <span class="version-text">{{ appVersion }}</span>
          </div>
        </div>

        <div class="footer">
          <div class="logout">
            <button @click="logoutBtn">
              <div class="item">
                로그아웃
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  </aside>
</template>

<script>
import { latestDeployDate, version } from '../../../package.json'
import { userService } from '../../router'

export default {
  name: 'leftLayout',
  data () {
    return {
      userInfo: {},
      menuList: [],
      currentPath: '',
      tableHeader: '',
      menuAuth: {
        'AplMaster': [
          '/HO001',
          '/MR001',
          '/MR002',
          '/GR001',
          '/GR101',
          '/GR102',
          '/GR201',
          '/GR202',
          '/GR301',
          '/GR302',
          '/CR001',
          '/CR101',
          '/CS001',
          '/CS002',
          '/CS003',
          '/CS004',
          '/CS101',
          '/CS102',
          '/CS103',
          '/CS105',
          '/CS106',
          '/SE001',
          '/SE002',
          '/SE003',
          '/SE004',
          '/SE201',
          '/SE202',
          '/SE203',
          '/SE204',
          '/SE211',
          '/MA001',
          '/MA002',
          '/MA003',
          '/MA004',
          '/MA011',
          '/MA101',
          '/HO201',
          '/RD001',
          '/RD002',
          '/CD001',
          '/CD002',
          '/ST001',
          '/ST002'
        ],
        'AplManager': [
          '/HO001',
          '/MR001',
          '/MR002',
          '/GR001',
          '/GR101',
          '/GR102',
          '/GR201',
          '/GR202',
          '/GR301',
          '/GR302',
          '/CR001',
          '/CR101',
          '/CS001',
          '/CS002',
          '/CS003',
          '/CS004',
          '/CS101',
          '/CS102',
          '/CS103',
          '/CS105',
          '/CS106',
          '/SE001',
          '/SE002',
          '/SE003',
          '/SE004',
          '/SE201',
          '/SE202',
          '/SE203',
          '/SE204',
          '/SE211',
          '/MA001',
          '/MA002',
          '/MA003',
          '/MA004',
          '/MA011',
          '/MA101',
          '/HO201',
          '/RD001',
          '/RD002',
          '/CD001',
          '/CD002',
          '/ST001',
          '/ST002'
        ],
        'AplDeveloper': [
          '/HO001',
          '/HO101',
          '/GR001',
          '/GR101',
          '/GR102',
          '/GR201',
          '/GR202',
          '/GR301',
          '/GR302',
          '/CR001',
          '/CR101',
          '/CS001',
          '/CS002',
          '/CS101',
          '/CS102',
          '/CS103',
          '/SE002',
          '/SE211',
          '/CD002'
        ],
        'ClubManager': [
          '/HO001',
          '/HO101',
          '/GR001',
          '/GR101',
          '/GR102',
          '/GR201',
          '/GR202',
          '/GR301',
          '/GR302',
          '/CR001',
          '/CR101',
          '/CS001',
          '/CS002',
          '/CS101',
          '/CS102',
          '/CS103',
          '/SE002',
          '/SE211',
          '/CD002',
          '/AccountClubs'
        ],
        'SktDeveloper': [
          '/HO001',
          '/HO101',
          '/GR001',
          '/GR101',
          '/GR102',
          '/GR201',
          '/GR202',
          '/GR301',
          '/GR302',
          '/CR001',
          '/CR101',
          '/CS001',
          '/CS002',
          '/CS101',
          '/CS102',
          '/CS103',
          '/SE002',
          '/SE211',
          '/CD002'
        ]
      },
      appVersion: `v${version}.${latestDeployDate}`
    }
  },
  created: function () {
    userService.getAll().then(response => {
      this.userInfo = response.data
      this.currentPath = window.location.pathname
      let menuList = document.querySelectorAll('.navigation li')
      menuList.forEach(it => {
        let menuData = it.getAttribute('el-data')
        let authCnt = 0
        this.menuAuth[this.userInfo.userRole].find(item => {
          if (item.indexOf(menuData) > -1) authCnt++
        })
        if (authCnt === 0) {
          it.remove()
        }
        if (this.currentPath.indexOf(menuData) > -1) {
          it.classList.add('active')
        }
      })
    })
    if (localStorage.getItem('sideMenu') === 'close' && document.querySelector('.type-content.asideActive') !== null) {
      document.querySelector('.type-content.asideActive').classList.remove('asideActive')
    } else {
      if (window.innerWidth < 1280) {
        if (document.querySelector('.type-content.asideActive') != null) {
          document.querySelector('.type-content.asideActive').classList.remove('asideActive')
          localStorage.setItem('sideMenu', 'close')
        }
      }
    }
  },
  mounted: function () {
    if (document.querySelector('.id-home-apl') || document.querySelector('.id-home-club') || document.querySelector('.id-monitoring-summary') ||
      document.querySelector('.id-monitoring-detail') || document.querySelector('.id-green-temperature-term') || document.querySelector('.id-green-apl') ||
      document.querySelector('.id-green-summary') || document.querySelector('.id-settings-notification-list') ||
      document.querySelector('.id-regionStatus-abnormal') || document.querySelector('.id-regionStatus-batteryCharge') ||
      document.querySelector('.id-golfClubStatus')) {
      if (document.querySelector('.fixed.grid') !== null) {
        if (document.querySelector('.dev_headerLine') !== null) {
          window.addEventListener('scroll', this.scrollEvt1)
        }
      }
      if (document.querySelector('.scroll-body') !== null) {
        if (document.querySelector('.body.dev_headerLine') !== null) {
          document.querySelector('.scroll-body').addEventListener('scroll', this.scrollEvt2)
        }
      }
    } else {
      if (document.querySelector('.fixed.grid') !== null) {
        if (document.querySelector('.dev_headerLine') !== null) {
          window.addEventListener('scroll', this.scrollEvt3)
        }
      }
      if (document.querySelector('.scroll-body') !== null) {
        if (document.querySelector('.dev_headerLine') !== null) {
          document.querySelector('.scroll-body').addEventListener('scroll', this.scrollEvt4)
        }
      }
    }
    if (navigator.userAgent.match(/iP(hone|od|ad)/)) {
      document.getElementsByName('viewport')[0].setAttribute('content', 'width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=0')
    } else {
      document.getElementsByName('viewport')[0].setAttribute('content', 'width=device-width, initial-scale=1.0')
    }
    if (navigator.userAgent.match(/Android|Mobile|iP(hone|od|ad)|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/)) {
      document.querySelector('body').classList.add('mobileClick')
    }
  },
  destroyed: function () {
    window.removeEventListener('scroll', this.scrollEvt1)
    window.removeEventListener('scroll', this.scrollEvt3)
    if (document.querySelector('.scroll-body') !== null) {
      document.querySelector('.scroll-body').removeEventListener('scroll', this.scrollEvt2)
      document.querySelector('.scroll-body').removeEventListener('scroll', this.scrollEvt4)
    }
  },
  methods: {
    menuToggle: function () {
      if (document.querySelector('.type-content.asideActive') == null) {
        document.querySelector('.type-content').classList.add('asideActive')
        localStorage.setItem('sideMenu', 'open')
      } else {
        document.querySelector('.type-content.asideActive').classList.remove('asideActive')
        localStorage.setItem('sideMenu', 'close')
      }
    },
    getCurrentCcodeParam: function () {
      let currentCcode = localStorage.getItem('currentCcode')
      if (currentCcode) {
        return `?ccode=${currentCcode}`
      } else {
        return ''
      }
    },
    accordionToggle: function (e) {
      document.querySelectorAll('.navigation > li.active').forEach(it => {
        it.classList.remove('active')
      })
      e.currentTarget.classList.toggle('active')
    },
    scrollEvt1: function () {
      let scrollY = window.scrollY || window.pageYOffset
      let tableHeader = document.querySelector('.fixed.grid')
      let tableHeaderLine = document.querySelector('.dev_headerLine')
      let headerLine = document.querySelector('.type-content header .header .toggle')

      if (scrollY > (tableHeaderLine.offsetTop - headerLine.scrollHeight)) {
        tableHeader.classList.add('active')
        tableHeader.style.marginLeft = '-' + (document.querySelector('.scroll-body').scrollLeft || window.scrollX || window.pageXOffset) + 'px'
      } else if (scrollY < (tableHeaderLine.offsetTop + headerLine.scrollHeight)) {
        tableHeader.classList.remove('active')
        tableHeader.style.marginLeft = '0px'
      }
    },
    scrollEvt2: function () {
      let scrollX = document.querySelector('.scroll-body').scrollLeft
      let scrollY = window.scrollY || window.pageYOffset
      let tableHeader = document.querySelector('.fixed.grid')

      if (scrollY > (document.querySelector('.dev_headerLine').offsetTop - document.querySelector('.type-content header .header .toggle').scrollHeight)) {
        tableHeader.classList.add('active')
        tableHeader.style.marginLeft = '-' + scrollX + 'px'
      } else if (scrollY < (document.querySelector('.dev_headerLine').offsetTop + document.querySelector('.type-content header .header .toggle').scrollHeight)) {
        tableHeader.classList.remove('active')
        tableHeader.style.marginLeft = '0px'
      }
    },
    scrollEvt3: function () {
      let scrollX = window.scrollX || window.pageXOffset
      let scrollY = window.scrollY || window.pageYOffset
      let tableHeader = document.querySelector('.fixed.grid')

      if (document.querySelector('.scroll-body').scrollLeft > 0) {
        scrollX = document.querySelector('.scroll-body').scrollLeft
      }
      if (scrollY > (document.querySelector('.scroll-body').offsetTop + document.querySelector('.dev_headerLine').offsetTop) - document.querySelector('.type-content header .header .toggle').scrollHeight) {
        tableHeader.classList.add('active')
        tableHeader.style.marginLeft = '-' + scrollX + 'px'
      } else if (scrollY < (document.querySelector('.scroll-body').offsetTop + document.querySelector('.dev_headerLine').offsetTop) - document.querySelector('.type-content header .header .toggle').scrollHeight) {
        tableHeader.classList.remove('active')
        tableHeader.style.marginLeft = '0px'
      }
    },
    scrollEvt4: function () {
      let scrollX = document.querySelector('.scroll-body').scrollLeft
      let scrollY = window.scrollY || window.pageYOffset
      if (scrollY > (document.querySelector('.scroll-body').offsetTop + document.querySelector('.dev_headerLine').offsetTop) - document.querySelector('.type-content header .header .toggle').scrollHeight) {
        document.querySelector('.fixed.grid').classList.add('active')
        document.querySelector('.fixed.grid').style.marginLeft = '-' + scrollX + 'px'
      } else if (scrollY < (document.querySelector('.scroll-body').offsetTop + document.querySelector('.dev_headerLine').offsetTop) - document.querySelector('.type-content header .header .toggle').scrollHeight) {
        document.querySelector('.fixed.grid').classList.remove('active')
        document.querySelector('.fixed.grid').style.marginLeft = '0px'
      }
    },
    goHome: function () {
      const userRole = this.$store.state.users.userInfo.userRole
      if (this.$route.path === '/HO001' && userRole !== 'ClubManager') return
      if (this.$route.path === '/HO101' && userRole === 'ClubManager') return
      this.moveMenu('/')
    }
  }
}
</script>

<style scoped>
.container .body {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.version {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}
.version .version-text {
  color: rgba(255, 255, 255, 0.5);
  letter-spacing: 1.5px;
  font-size: 0.9rem;
  cursor: default;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/Left.vue